import { Component, OnInit, Input } from '@angular/core';
import { Education } from '../../../shared/models/education';
import { CandidateStore } from '../../../dashboards/store/candidate-store';
import { AppStore } from '../../../shared/store/lookup-store.service';

@Component({
  selector: 'app-education-preview',
  templateUrl: './education-preview.component.html',
  styleUrls: ['./education-preview.component.scss']
})
export class EducationPreviewComponent implements OnInit {
  @Input() education: Education;
  @Input() index: number;
  @Input() readonly: boolean;

  showEditForm: boolean = false;

  constructor(private dashboardState: CandidateStore, private lookupStore: AppStore) {
    this.dashboardState.educations.subscribe(edu => {
      if (!edu) {
        return;
      } else {
        edu.forEach(e => {
          if(!e) {
            return;
          }

          const educationLevelValue = this.lookupStore.getEducationLevel(e.educationLevelId).value;
          e.setTitle(educationLevelValue);
        });
      }

      if(!this.education) {
        return;
      }

      const foundIndex = edu.indexOf(this.education);
      this.index = foundIndex;
    });
  }

  ngOnInit() {
  }

  editEducation(): void {
    if (this.showEditForm) {
      this.showEditForm = false;
    } else {
      this.showEditForm = true;
    }
  }

  deleteEducation(): void {
    this.dashboardState.removeEducation(this.index);
  }

  educationSaved(): void {
    this.showEditForm = false;
  }

}
